import {AbstractParameter} from "parameters/AbstractParameter.js";

export default superclass => class extends superclass  {
    initDisabledParameters() {
        this.parametersDisabledParameter = new AbstractParameter(
            "parametersDisabled",
            this,
            (o, x) => this.parametersDisabledChanged(x),
            {
                defaultValue: []
            });
        this.registerParameter(this.parametersDisabledParameter);
    }

    get parametersDisabled() {
        return this.parametersDisabledParameter.get(true);
    }

    parametersDisabledChanged(x) {
        let bulk = {};
        for (let i of x) {
            let value = this.initialParameterValues[i];
            if (value !== undefined && this._parameters[i]) {
                let {id} = this._parameters[i].set(
                    value, true, true, undefined,
                    this.rampTime / 1000.0);
                bulk[id] = value;
            }
        }
        this.setEffectParameterValues(bulk);
    }
}
